import React from "react";

export default function SpecificationSection() {
  return (
    <div className="innerDetail">
      <div className="innerDetail__imageWrapper">
        <img
          src="/images/GalaxyA50.png"
          alt="galaxy a50"
          className="imgProduct"
        />
      </div>
      <br />
      <br />
      <p>
        Sapien faucibus et molestie ac. Nulla posuere sollicitudin aliquam
        ultrices sagittis orci a. Viverra vitae congue eu consequat. Nam libero
        justo laoreet sit amet cursus. Vestibulum rhoncus est pellentesque elit.
        Suspendisse potenti nullam ac tortor vitae purus faucibus. Posuere
        sollicitudin aliquam ultrices sagittis. Dictumst quisque sagittis purus
        sit amet volutpat. Adipiscing vitae proin sagittis nisl. Dignissim
        convallis aenean et tortor. Pellentesque habitant morbi tristique
        senectus et netus et. Acru non sodales neque sodales ut etiam sit.
        Vulputate ut pharetra sit amet aliquam.
      </p>
    </div>
  );
}
